<template>
  <v-card outlined class="elevation-0 mt-5">
    <v-card-title>メッセージ履歴</v-card-title>
    <v-card-text>
      <el-table
          :data="contractMessages"
          :class="{'hide-empty-text': loading}">
        <el-table-column
            label="区分"
            prop="requestType"
            align="center"
            width="80">
          <template #default="{row}">
            {{ contractMessageRequestTypes[row.requestType] }}
          </template>
        </el-table-column>
        <el-table-column
            label="メッセージ"
            column-key="message"
            class-name="message">
          <template #default="{row}">
            <div :class="{'message-wrapper': true, 'other': row.isOther, 'self': row.isSelf}">
              <span class="sender">
                <span class="owner">{{ row.isSelf ? account.owner.name : tradeContract.companionOwnerName }}</span>
                <span class="terminal">{{ row.isSelf ? account.user.terminal.name : tradeContract.companionTerminalName }}</span>
              </span>
              <div class="message-line">
                <span class="speech-bubble">{{ row.message }}</span>
                <el-tooltip :content="formatDateTime(row.createdAt)" placement="bottom" :open-delay="500">
                  <span class="send-time">{{ formatDateTimeRelative(row.createdAt) }}</span>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>

        <template #append>
          <v-row
              justify="center"
              class="pa-10"
              v-if="loading">
            <v-progress-circular indeterminate/>
          </v-row>
        </template>
      </el-table>
    </v-card-text>
  </v-card>
</template>

<script>
import {CONTRACT_MESSAGE_REQUEST_TYPES} from "@/constants";
import TradeContractView from "@/components/pages/contract/TradeContract/TradeContractView";
import Formatter from "@/utils/Formatter";
import {mapGetters} from "vuex";

export default {
  name: "MessageHistory",
  mixins: [Formatter],
  props: {
    tradeContract: {
      type: TradeContractView,
      require: true,
    }
  },
  data() {
    return {
      loading: true,
      contractMessages: [],
      contractMessageRequestTypes: CONTRACT_MESSAGE_REQUEST_TYPES,
    };
  },
  mounted() {
    this.$watch(
        () => this.tradeContract.id,
        tradeContractId => {
          if(tradeContractId) {
            this.load();
          }
        },
        { immediate: true }
    );
  },
  computed: {
    ...mapGetters({
      account: 'hcs/account',
      hcsClient: 'hcs/client',
    }),
  },
  methods: {
    async load() {
      const {data: contractMessages} = await this.hcsClient.get('/contract_messages', {params: {tradeContractIdEq: this.tradeContract.id}});
      const selfTerminalId = this.account.user.terminalId;
      this.contractMessages = contractMessages.map(cm => ({
        ...cm,
        isOther: cm.destinationTerminalId === selfTerminalId,
        isSelf: cm.sourceTerminalId === selfTerminalId
      }));
      this.loading = false;
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep tbody {
  td.el-table__cell.message {
    background-color: #a8c2e8;
    border-bottom: 1px solid #99bbec;
  }

  tr:hover td.el-table__cell.message {
    background-color: #93b5e5 !important;
  }
}

.message-wrapper {
  display: flex;
  flex-direction: column;

  &.other {
    align-items: flex-start;
  }

  &.self {
    align-items: flex-end;
  }
}

.message-line {
  display: flex;
  align-items: flex-end;

  .other & {
    flex-direction: row;
  }

  .self & {
    flex-direction: row-reverse;
  }
}

.sender {
  display: block;
  font-size: 80%;
  font-weight: bold;

  *:not(:first-child) {
    padding-left: 5px;
  }
}

.send-time {
  font-size: 80%;
}

.speech-bubble {
  color: black;
  padding: 10px 20px;
  display: inline-block;
  white-space: pre-wrap;
  position: relative;
  border-radius: .4em;

  .other & {
    margin: 0 10px 0 10px;
    background: #ffffff;
  }

  .other &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 0;
    height: 0;
    border: 12px solid transparent;
    border-right-color: #ffffff;
    border-left: 0;
    border-top: 0;
    margin-top: -6px;
    margin-left: -12px;
  }

  .self & {
    margin: 0 10px 0 10px;
    background: #85e449;
  }

  .self &:after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    width: 0;
    height: 0;
    border: 12px solid transparent;
    border-left-color: #85e449;
    border-right: 0;
    border-top: 0;
    margin-top: -6px;
    margin-right: -12px;
  }
}
</style>
